import { MSP_CONSTANTS } from './constant';

export const isItManager = (enterpriseType: string): boolean => {
  switch (enterpriseType) {
    case MSP_CONSTANTS.mspManager:
      return true;
    case MSP_CONSTANTS.multiOrgManager:
      return true;
    default:
      return false;
  }
};

export const isItManaged = (enterpriseType: string): boolean => {
  switch (enterpriseType) {
    case MSP_CONSTANTS.mspManaged:
      return true;
    case MSP_CONSTANTS.multiOrgManaged:
      return true;
    default:
      return false;
  }
};
